import { Component, OnInit } from '@angular/core';
import { AdalService } from '../../authentication/adal.service'

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

    isAuthenticated: boolean = true;

    constructor(private adalSvc: AdalService) {}

    ngOnInit() {
        if (this.adalSvc.isLogged) {
            console.log('Logged out');
            this.adalSvc.logout();
        }
        this.isAuthenticated = false;
    }
} 